import { useMapContext } from '@components/map/MapContext';
import { useMapSelectPosition } from '@hooks/useMapSelectPosition';
import { useSelectorWithMapId } from '@hooks/useSelectorWithMapId';
import { selectPoiBySelectedOptions } from '@redux/config/config.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { Layer, Source } from 'react-map-gl/mapbox';

import { SourceNameEnum } from '@/types/map.types';

import { poiLayer } from './poi.layer';

function PoiLayer() {
  const { isSelectionEnabled, setSelectedPosition } = useMapContext();
  const poiFeatures = useSelectorWithMapId(selectPoiBySelectedOptions);
  useMapSelectPosition(isSelectionEnabled, setSelectedPosition);
  if (!isFeatureCollection(poiFeatures)) return null;

  return (
    <Source id={SourceNameEnum.POIS} type="geojson" data={poiFeatures}>
      <Layer {...poiLayer} />
    </Source>
  );
}

export default PoiLayer;
